module.exports = __webpack_public_path__ + "public/images/netw-soon-main.69f88f6463825212f404345ddb51a048.webp";